import submit from "submit-form";
import { truncateText } from "../../utils/string-helpers";
import Dropdown from "../dropdown";
import DropdownFocus from "../dropdown-focus";

type Option = {
  text?: string;
  label?: string;
  value: string;
};

interface SelectProps {
  name: string;
  options: Option[];
  onChange?: (value: string) => void;
  title?: string;
  value?: string;
  disabled?: boolean;
  withFocus?: boolean;
  withTruncate?: boolean;
  overlay?: boolean;
  /** When `overlay` is true, force the list above the summary (e.g. bottom toolbar). */
  openUpward?: boolean;
  alignRight?: boolean;
  form?: string;
  /** Shown in the closed control when value is not listed in options */
  openUpward?: boolean;
  alignRight?: boolean;
  form?: string;
  displayLabel?: string;
}

function Select({
  name,
  options,
  onChange,
  title,
  value,
  disabled = false,
  withFocus = false,
  withTruncate = false,
  overlay = false,
  openUpward = false,
  alignRight = false,
  form,
  displayLabel,
}: SelectProps) {
  const summaryText = (() => {
    if (displayLabel) {
      return displayLabel;
    }
    if (!options?.length) {
      return value === undefined || value === null ? "" : String(value);
    }
    const match = options.find((item: Option) => {
      if (value === "" || value === undefined || value === null) {
        return false;
      }
      return String(item.value) === String(value);
    });
    if (match?.text != null && match.text !== "") return match.text;
    if (match?.label != null && match.label !== "") return match.label;
    if (value === undefined || value === null || value === "") return "";
    return String(value);
  })();

  const dropdownProps = {
    options,
    summaryText: withTruncate ? truncateText(summaryText, 30) : summaryText,
    onSelectFn: (newVal: string) => {
      if (onChange) return onChange(newVal);

      submit(`/actions/refresh`, {
        method: "GET",
        body: { [name]: newVal },
      });
    },
    disabled,
    alignRight,
  };

  return (
    <>
      {title && <label htmlFor={name}>{title}</label>}
      <input
        type="hidden"
        name={name}
        value={value}
        form={form}
        onChange={() => {}}
      />
      {withFocus ? (
        <DropdownFocus {...dropdownProps} />
      ) : (
        <Dropdown
          {...dropdownProps}
          overlay={overlay}
          openUpward={openUpward}
        />
      )}
    </>
  );
}

export default Select;
